<template>
    <div>
      <v-footer flat class="px-0">
        <div class="row py-4 primary px-0 mx-0">
          <div class="col-lg-2 col-md-2 col-xs-12 q-px-sm"></div>
          <div class="col-lg-3 col-md-3 col-xs-12 q-px-sm white--text">
            <p class="text-h6 mb-1">Dirección</p>
                           
                <p class="mb-0">
                   <v-icon dark>mdi-map-marker</v-icon>
                   Carretera Villahermosa a Teapa Km. 24 R/a Huasteca 1ra Sección C.P 86298
                </p>
            
            <p class="mb-0" style="white-space: nowrap">
              <v-icon dark>mdi-email</v-icon>
              comercializadoraserviciosadecv@hotmail.com
            </p>
          </div>
          <div
            class="col-lg-3 col-md-3 col-xs-12 q-px-lg text-center white--text"
          >
            <p class="text-h6 mb-1">Atención</p>
            <p class="mb-1 white--text">
              <a
                style="text-decoration: none"
                class="white--text"
                href="tel:+529931408912"
                target="_blank"
              >
                <span><v-icon dark>mdi-phone</v-icon></span>(993) 1-40-89-12 
              </a>
            </p>
            <p class="mb-1">
              <a
                style="text-decoration: none"
                class="white--text"
                href="tel:+529931550572"
                target="_blank"
              >
                <span><v-icon dark>mdi-phone</v-icon></span>(993) 1-55-05-72</a
              >
            </p>
            <p class="mb-1">
              <a
                style="text-decoration: none"
                class="white--text"
                href=" https://wa.me/15551234567"
                target="_blank"
              >
                <span><v-icon dark>mdi-whatsapp</v-icon></span>(993) 1-55-05-72</a
              >
            </p>
          </div>
          <div class="col-lg-3 col-md-3 col-xs-12 q-px-lg white--text">
            <p class="text-h6 mb-1">Horarios</p>
            <p class="mb-1">
              <span><v-icon dark>mdi-store-clock</v-icon></span> Lunes a Viernes 8am a 5pm
            </p>
            <p class="mb-1">
              <span><v-icon dark>mdi-store-clock</v-icon></span> Sábados y Domingos 8am a 3pm
            </p>
          </div>
        </div>
      </v-footer>
    </div>
  </template>
  <script>
  export default {
    name: 'FooterTwo'
  }
  </script>
  